import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data";

export const TaglineMarquee = () => (
  <div
    data-testid="tagline-marquee"
    className="relative border-y border-amber/20 bg-night py-6 overflow-hidden"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-2xl md:text-3xl text-cream/70 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-amber inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
